// extracted by mini-css-extract-plugin
export default {"paymentError":"payment-error_paymentError__da+2p","paymentErrorTitle":"payment-error_paymentErrorTitle__GV0cG","paymentErrorText":"payment-error_paymentErrorText__McqlS"};